// Traduções da Programação do portal, coletadas por glob em core/i18n/messages.ts.
// Sem parêntese nem travessão no texto: a informação secundária vai em outra linha.
export default {
  pt: {
    'portal.programacao.cargas': 'Cargas',
    'portal.programacao.nEnvios': 'Envios: {{n}}',
    'portal.programacao.cargasAgoraN': 'Cargas: {{n}}',
    'portal.programacao.confirmar': 'Confirmar',
    'portal.programacao.deN': '{{n}} de {{total}}',
    'portal.programacao.detalhe.aguardandoPlaca': 'Aguardando a liberação',
    'portal.programacao.detalhe.atualizadaEm': 'Última atualização às {{em}}',
    'portal.programacao.dicaPlacas': 'Cargas com as placas liberadas pela equipe',
    'portal.programacao.faixa': '{{de}} às {{ate}}',
    'portal.programacao.horarios': 'Horários',
    'portal.programacao.local': 'Fazenda e destino',
    'portal.programacao.placas': 'Placas liberadas',
    'portal.programacao.reprogramar.mudancas': 'Mudanças',
    'portal.programacao.resumo': 'Resumo',
    'portal.programacao.status': 'Status',
    'portal.programacao.detalhe.tipo.criacao': 'Programação enviada',
    'portal.programacao.detalhe.tipo.reprogramacao': 'Reprogramada',
    'portal.programacao.detalhe.tipo.confirmacao': 'Prévia confirmada',
    'portal.programacao.detalhe.tipo.ajuste_equipe': 'Ajustada pela equipe',
    'programacao.status.previa': 'Prévia',
    'programacao.status.confirmada': 'Confirmada',
    'programacao.envio.criacao': 'Enviada {{h}}',
    'programacao.envio.reprogramacao': 'Reprogramada {{h}}',
    'programacao.envio.confirmacao': 'Confirmada {{h}}',
    'programacao.envio.ajuste_equipe': 'Ajustada pela equipe {{h}}',

    'portal.programacao.title': 'Programação',
    'portal.programacao.eyebrow': 'Portal do cliente',
    'portal.programacao.subtitle': 'Escolha o dia e envie as cargas de cada contrato.',
    'portal.programacao.hoje': 'Hoje',
    'portal.programacao.amanha': 'Amanhã',
    'portal.programacao.outraData': 'Outra data',
    'portal.programacao.diasAria': 'Dia da programação',
    'portal.programacao.badgeProgramacoes': '{{n}} programadas',
    'portal.programacao.carregando': 'Carregando a programação do dia',
    'portal.programacao.erro': 'Não foi possível carregar a programação do dia.',
    'portal.programacao.vazioTitulo': 'Nada programado para {{dia}}',
    'portal.programacao.vazioTexto': 'Envie a programação de cada contrato. Pode ser uma prévia, que você confirma depois.',
    'portal.programacao.fazenda': 'Fazenda',
    'portal.programacao.destino': 'Destino',
    'portal.programacao.produtor': 'Produtor',
    'portal.programacao.contrato': 'Contrato',
    'portal.programacao.dia': 'Dia',
    'portal.programacao.naoInformado': 'Não informado',
    'portal.programacao.umaCarga': '1 carga',
    'portal.programacao.nCargas': '{{n}} cargas',
    'portal.programacao.dasAs': 'das {{de}} às {{ate}}',
    'portal.programacao.as': 'às {{h}}',
    'portal.programacao.placasLiberadas': 'Placas liberadas: {{n}}',
    'portal.programacao.ver': 'Ver',
    'portal.programacao.reprogramarAcao': 'Reprogramar',
    'portal.programacao.confirmarPrevia': 'Confirmar prévia',
    'portal.programacao.diaPassado': 'O dia já passou. A programação fica só para consulta.',
    'portal.programacao.cargasAgora': 'Cargas agora',
    'portal.programacao.enviando': 'Enviando',
    'portal.programacao.sairTitulo': 'Sair sem enviar?',
    'portal.programacao.sairTexto': 'O que você mudou nesta tela ainda não foi enviado.',
    'portal.programacao.sairConfirmar': 'Sair sem enviar',
    'portal.programacao.ficar': 'Continuar aqui',

    'portal.programacao.nova.titulo': 'Nova programação',
    'portal.programacao.nova.secaoTipo': 'Tipo da programação',
    'portal.programacao.nova.tipoTexto.previa': 'Pode mudar até você confirmar',
    'portal.programacao.nova.tipoTexto.confirmada': 'A programação do dia',
    'portal.programacao.nova.secaoContrato': 'Contrato e dia',
    'portal.programacao.nova.contrato': 'Contrato',
    'portal.programacao.nova.buscarContrato': 'Buscar pelo número, produtor ou fazenda',
    'portal.programacao.nova.dia': 'Dia do carregamento',
    'portal.programacao.nova.reprogramarEsta': 'Reprogramar esta',
    'portal.programacao.nova.duplicadaTitulo': 'Este contrato já tem programação para {{dia}}',
    'portal.programacao.nova.duplicadaTexto': 'Para mudar as cargas, reprograme a que já existe.',
    'portal.programacao.nova.secaoCargas': 'Cargas',
    'portal.programacao.nova.quantidade': 'Quantidade',
    'portal.programacao.nova.ateN': 'Até {{n}}',
    'portal.programacao.nova.primeiro': 'Primeiro horário',
    'portal.programacao.nova.intervalo': 'Intervalo entre cargas',
    'portal.programacao.nova.enviar': 'Enviar programação',
    'portal.programacao.nova.enviada': 'Programação enviada. O programador já foi avisado.',
    'portal.programacao.nova.enviadaPrevia': 'Prévia enviada. Confirme quando souber as cargas do dia.',
    'portal.programacao.nova.confirmarTitulo': 'Enviar a programação?',
    'portal.programacao.nova.confirmarPrevia': 'Enviar a prévia?',
    'portal.programacao.nova.confirmarTexto': '{{qtd}} no contrato {{contrato}}, para {{dia}}.',

    'portal.programacao.reprogramar.titulo': 'Reprogramar',
    'portal.programacao.reprogramar.tituloConfirmar': 'Confirmar a prévia',
    'portal.programacao.reprogramar.secaoPrevia': 'Esta programação é uma prévia',
    'portal.programacao.reprogramar.manter': 'Continuar como prévia',
    'portal.programacao.reprogramar.manterTexto': 'Envia as mudanças e confirma depois.',
    'portal.programacao.reprogramar.confirmar': 'Confirmar a programação',
    'portal.programacao.reprogramar.confirmarTexto': 'A prévia passa a ser a programação do dia, com as mudanças desta tela.',
    'portal.programacao.reprogramar.secaoCargas': 'Cargas',
    'portal.programacao.reprogramar.nadaMudou': 'Nada mudou ainda',
    'portal.programacao.reprogramar.extras': 'Cargas novas',
    'portal.programacao.reprogramar.reducoes': 'Cargas que saem',
    'portal.programacao.reprogramar.horarios': 'Horários mudados',
    'portal.programacao.reprogramar.viraConfirmada': 'Vira confirmada',
    'portal.programacao.reprogramar.revisar': 'Revisar e enviar',
    'portal.programacao.reprogramar.revisaoTitulo': 'Confirmar a reprogramação',
    'portal.programacao.reprogramar.revisaoConfirmar': 'Confirmar a programação',
    'portal.programacao.reprogramar.antes': 'Antes',
    'portal.programacao.reprogramar.agora': 'Agora',
    'portal.programacao.reprogramar.legenda': 'Em destaque, os horários que mudam.',
    'portal.programacao.reprogramar.enviar': 'Enviar',
    'portal.programacao.reprogramar.enviada': 'Reprogramação enviada. O programador já foi avisado.',
    'portal.programacao.reprogramar.confirmada': 'Programação confirmada. O programador já foi avisado.',
    'portal.programacao.reprogramar.mudou': 'A programação mudou enquanto você editava. A tela foi atualizada; confira e envie de novo.',

    'portal.programacao.detalhe.titulo': 'Programação {{contrato}}',
    'portal.programacao.detalhe.carga': 'Carga',
    'portal.programacao.detalhe.horario': 'Horário',
    'portal.programacao.detalhe.cavalo': 'Cavalo',
    'portal.programacao.detalhe.carretas': 'Carretas',
    'portal.programacao.detalhe.motorista': 'Motorista',
    'portal.programacao.detalhe.enviadaEm': 'Enviada em',
    'portal.programacao.detalhe.confirmadaEm': 'Confirmada em',
    'portal.programacao.detalhe.envios': 'Envios',
    'portal.programacao.detalhe.semCargas': 'Nenhuma carga nesta programação.',
    'portal.programacao.detalhe.ajustesTitulo': 'Ajustes da equipe',
    'portal.programacao.detalhe.ajustesTexto': 'A equipe ajustou esta programação. Se algo não confere, fale com a equipe.',
    'portal.programacao.detalhe.entraram': 'Entraram',
    'portal.programacao.detalhe.sairam': 'Saíram',
    'portal.programacao.detalhe.horariosAlterados': 'Horários mudados: {{n}}',
    'portal.programacao.detalhe.placasTitulo': 'Placas que vão atender',
    'portal.programacao.detalhe.placasTexto': 'As placas que o programador liberou, para a emissão da nota.',
    'portal.programacao.detalhe.semPlacas': 'O programador ainda não liberou as placas desta programação.',
  },
  en: {
    'portal.programacao.cargas': 'Loads',
    'portal.programacao.nEnvios': 'Submissions: {{n}}',
    'portal.programacao.cargasAgoraN': 'Loads: {{n}}',
    'portal.programacao.confirmar': 'Confirm',
    'portal.programacao.deN': '{{n}} of {{total}}',
    'portal.programacao.detalhe.aguardandoPlaca': 'Waiting for release',
    'portal.programacao.detalhe.atualizadaEm': 'Last update at {{em}}',
    'portal.programacao.dicaPlacas': 'Loads with the plates released by the team',
    'portal.programacao.faixa': '{{de}} to {{ate}}',
    'portal.programacao.horarios': 'Times',
    'portal.programacao.local': 'Farm and destination',
    'portal.programacao.placas': 'Plates released',
    'portal.programacao.reprogramar.mudancas': 'Changes',
    'portal.programacao.resumo': 'Summary',
    'portal.programacao.status': 'Status',
    'portal.programacao.detalhe.tipo.criacao': 'Schedule sent',
    'portal.programacao.detalhe.tipo.reprogramacao': 'Rescheduled',
    'portal.programacao.detalhe.tipo.confirmacao': 'Preview confirmed',
    'portal.programacao.detalhe.tipo.ajuste_equipe': 'Adjusted by the team',
    'programacao.status.previa': 'Preview',
    'programacao.status.confirmada': 'Confirmed',
    'programacao.envio.criacao': 'Sent {{h}}',
    'programacao.envio.reprogramacao': 'Rescheduled {{h}}',
    'programacao.envio.confirmacao': 'Confirmed {{h}}',
    'programacao.envio.ajuste_equipe': 'Adjusted by the team {{h}}',

    'portal.programacao.title': 'Schedule',
    'portal.programacao.eyebrow': 'Customer portal',
    'portal.programacao.subtitle': 'Pick the day and send the loads of each contract.',
    'portal.programacao.hoje': 'Today',
    'portal.programacao.amanha': 'Tomorrow',
    'portal.programacao.outraData': 'Other date',
    'portal.programacao.diasAria': 'Schedule day',
    'portal.programacao.badgeProgramacoes': '{{n}} scheduled',
    'portal.programacao.carregando': 'Loading the day schedule',
    'portal.programacao.erro': 'Could not load the day schedule.',
    'portal.programacao.vazioTitulo': 'Nothing scheduled for {{dia}}',
    'portal.programacao.vazioTexto': 'Send the schedule of each contract. It can be a preview, which you confirm later.',
    'portal.programacao.fazenda': 'Farm',
    'portal.programacao.destino': 'Destination',
    'portal.programacao.produtor': 'Producer',
    'portal.programacao.contrato': 'Contract',
    'portal.programacao.dia': 'Day',
    'portal.programacao.naoInformado': 'Not informed',
    'portal.programacao.umaCarga': '1 load',
    'portal.programacao.nCargas': '{{n}} loads',
    'portal.programacao.dasAs': 'from {{de}} to {{ate}}',
    'portal.programacao.as': 'at {{h}}',
    'portal.programacao.placasLiberadas': 'Plates released: {{n}}',
    'portal.programacao.ver': 'View',
    'portal.programacao.reprogramarAcao': 'Reschedule',
    'portal.programacao.confirmarPrevia': 'Confirm preview',
    'portal.programacao.diaPassado': 'The day has passed. The schedule is read only.',
    'portal.programacao.cargasAgora': 'Loads now',
    'portal.programacao.enviando': 'Sending',
    'portal.programacao.sairTitulo': 'Leave without sending?',
    'portal.programacao.sairTexto': 'What you changed on this screen has not been sent.',
    'portal.programacao.sairConfirmar': 'Leave without sending',
    'portal.programacao.ficar': 'Stay here',

    'portal.programacao.nova.titulo': 'New schedule',
    'portal.programacao.nova.secaoTipo': 'Schedule type',
    'portal.programacao.nova.tipoTexto.previa': 'Can change until you confirm',
    'portal.programacao.nova.tipoTexto.confirmada': 'The schedule of the day',
    'portal.programacao.nova.secaoContrato': 'Contract and day',
    'portal.programacao.nova.contrato': 'Contract',
    'portal.programacao.nova.buscarContrato': 'Search by number, producer or farm',
    'portal.programacao.nova.dia': 'Loading day',
    'portal.programacao.nova.reprogramarEsta': 'Reschedule this one',
    'portal.programacao.nova.duplicadaTitulo': 'This contract already has a schedule for {{dia}}',
    'portal.programacao.nova.duplicadaTexto': 'To change the loads, reschedule the existing one.',
    'portal.programacao.nova.secaoCargas': 'Loads',
    'portal.programacao.nova.quantidade': 'Quantity',
    'portal.programacao.nova.ateN': 'Up to {{n}}',
    'portal.programacao.nova.primeiro': 'First time',
    'portal.programacao.nova.intervalo': 'Interval between loads',
    'portal.programacao.nova.enviar': 'Send schedule',
    'portal.programacao.nova.enviada': 'Schedule sent. The scheduler has been notified.',
    'portal.programacao.nova.enviadaPrevia': 'Preview sent. Confirm it when you know the loads of the day.',
    'portal.programacao.nova.confirmarTitulo': 'Send the schedule?',
    'portal.programacao.nova.confirmarPrevia': 'Send the preview?',
    'portal.programacao.nova.confirmarTexto': '{{qtd}} on contract {{contrato}}, for {{dia}}.',

    'portal.programacao.reprogramar.titulo': 'Reschedule',
    'portal.programacao.reprogramar.tituloConfirmar': 'Confirm the preview',
    'portal.programacao.reprogramar.secaoPrevia': 'This schedule is a preview',
    'portal.programacao.reprogramar.manter': 'Keep as preview',
    'portal.programacao.reprogramar.manterTexto': 'Sends the changes and you confirm later.',
    'portal.programacao.reprogramar.confirmar': 'Confirm the schedule',
    'portal.programacao.reprogramar.confirmarTexto': 'The preview becomes the schedule of the day, with the changes on this screen.',
    'portal.programacao.reprogramar.secaoCargas': 'Loads',
    'portal.programacao.reprogramar.nadaMudou': 'Nothing changed yet',
    'portal.programacao.reprogramar.extras': 'New loads',
    'portal.programacao.reprogramar.reducoes': 'Loads leaving',
    'portal.programacao.reprogramar.horarios': 'Times changed',
    'portal.programacao.reprogramar.viraConfirmada': 'Becomes confirmed',
    'portal.programacao.reprogramar.revisar': 'Review and send',
    'portal.programacao.reprogramar.revisaoTitulo': 'Confirm the reschedule',
    'portal.programacao.reprogramar.revisaoConfirmar': 'Confirm the schedule',
    'portal.programacao.reprogramar.antes': 'Before',
    'portal.programacao.reprogramar.agora': 'Now',
    'portal.programacao.reprogramar.legenda': 'Highlighted, the times that change.',
    'portal.programacao.reprogramar.enviar': 'Send',
    'portal.programacao.reprogramar.enviada': 'Reschedule sent. The scheduler has been notified.',
    'portal.programacao.reprogramar.confirmada': 'Schedule confirmed. The scheduler has been notified.',
    'portal.programacao.reprogramar.mudou': 'The schedule changed while you were editing. The screen was refreshed; check it and send again.',

    'portal.programacao.detalhe.titulo': 'Schedule {{contrato}}',
    'portal.programacao.detalhe.carga': 'Load',
    'portal.programacao.detalhe.horario': 'Time',
    'portal.programacao.detalhe.cavalo': 'Truck',
    'portal.programacao.detalhe.carretas': 'Trailers',
    'portal.programacao.detalhe.motorista': 'Driver',
    'portal.programacao.detalhe.enviadaEm': 'Sent at',
    'portal.programacao.detalhe.confirmadaEm': 'Confirmed at',
    'portal.programacao.detalhe.envios': 'Submissions',
    'portal.programacao.detalhe.semCargas': 'No loads in this schedule.',
    'portal.programacao.detalhe.ajustesTitulo': 'Team adjustments',
    'portal.programacao.detalhe.ajustesTexto': 'The team adjusted this schedule. If something does not match, talk to the team.',
    'portal.programacao.detalhe.entraram': 'Added',
    'portal.programacao.detalhe.sairam': 'Removed',
    'portal.programacao.detalhe.horariosAlterados': 'Times changed: {{n}}',
    'portal.programacao.detalhe.placasTitulo': 'Plates that will serve you',
    'portal.programacao.detalhe.placasTexto': 'The plates the scheduler released, to issue the invoice.',
    'portal.programacao.detalhe.semPlacas': 'The scheduler has not released the plates of this schedule yet.',
  },
  es: {
    'portal.programacao.cargas': 'Cargas',
    'portal.programacao.nEnvios': 'Envíos: {{n}}',
    'portal.programacao.cargasAgoraN': 'Cargas: {{n}}',
    'portal.programacao.confirmar': 'Confirmar',
    'portal.programacao.deN': '{{n}} de {{total}}',
    'portal.programacao.detalhe.aguardandoPlaca': 'Esperando la liberación',
    'portal.programacao.detalhe.atualizadaEm': 'Última actualización a las {{em}}',
    'portal.programacao.dicaPlacas': 'Cargas con las placas liberadas por el equipo',
    'portal.programacao.faixa': '{{de}} a {{ate}}',
    'portal.programacao.horarios': 'Horarios',
    'portal.programacao.local': 'Hacienda y destino',
    'portal.programacao.placas': 'Placas liberadas',
    'portal.programacao.reprogramar.mudancas': 'Cambios',
    'portal.programacao.resumo': 'Resumen',
    'portal.programacao.status': 'Estado',
    'portal.programacao.detalhe.tipo.criacao': 'Programación enviada',
    'portal.programacao.detalhe.tipo.reprogramacao': 'Reprogramada',
    'portal.programacao.detalhe.tipo.confirmacao': 'Previa confirmada',
    'portal.programacao.detalhe.tipo.ajuste_equipe': 'Ajustada por el equipo',
    'programacao.status.previa': 'Previa',
    'programacao.status.confirmada': 'Confirmada',
    'programacao.envio.criacao': 'Enviada {{h}}',
    'programacao.envio.reprogramacao': 'Reprogramada {{h}}',
    'programacao.envio.confirmacao': 'Confirmada {{h}}',
    'programacao.envio.ajuste_equipe': 'Ajustada por el equipo {{h}}',

    'portal.programacao.title': 'Programación',
    'portal.programacao.eyebrow': 'Portal del cliente',
    'portal.programacao.subtitle': 'Elija el día y envíe las cargas de cada contrato.',
    'portal.programacao.hoje': 'Hoy',
    'portal.programacao.amanha': 'Mañana',
    'portal.programacao.outraData': 'Otra fecha',
    'portal.programacao.diasAria': 'Día de la programación',
    'portal.programacao.badgeProgramacoes': '{{n}} programadas',
    'portal.programacao.carregando': 'Cargando la programación del día',
    'portal.programacao.erro': 'No fue posible cargar la programación del día.',
    'portal.programacao.vazioTitulo': 'Nada programado para {{dia}}',
    'portal.programacao.vazioTexto': 'Envíe la programación de cada contrato. Puede ser una previa, que usted confirma después.',
    'portal.programacao.fazenda': 'Hacienda',
    'portal.programacao.destino': 'Destino',
    'portal.programacao.produtor': 'Productor',
    'portal.programacao.contrato': 'Contrato',
    'portal.programacao.dia': 'Día',
    'portal.programacao.naoInformado': 'No informado',
    'portal.programacao.umaCarga': '1 carga',
    'portal.programacao.nCargas': '{{n}} cargas',
    'portal.programacao.dasAs': 'de las {{de}} a las {{ate}}',
    'portal.programacao.as': 'a las {{h}}',
    'portal.programacao.placasLiberadas': 'Placas liberadas: {{n}}',
    'portal.programacao.ver': 'Ver',
    'portal.programacao.reprogramarAcao': 'Reprogramar',
    'portal.programacao.confirmarPrevia': 'Confirmar previa',
    'portal.programacao.diaPassado': 'El día ya pasó. La programación queda solo para consulta.',
    'portal.programacao.cargasAgora': 'Cargas ahora',
    'portal.programacao.enviando': 'Enviando',
    'portal.programacao.sairTitulo': '¿Salir sin enviar?',
    'portal.programacao.sairTexto': 'Lo que cambió en esta pantalla todavía no fue enviado.',
    'portal.programacao.sairConfirmar': 'Salir sin enviar',
    'portal.programacao.ficar': 'Seguir aquí',

    'portal.programacao.nova.titulo': 'Nueva programación',
    'portal.programacao.nova.secaoTipo': 'Tipo de programación',
    'portal.programacao.nova.tipoTexto.previa': 'Puede cambiar hasta que usted confirme',
    'portal.programacao.nova.tipoTexto.confirmada': 'La programación del día',
    'portal.programacao.nova.secaoContrato': 'Contrato y día',
    'portal.programacao.nova.contrato': 'Contrato',
    'portal.programacao.nova.buscarContrato': 'Buscar por número, productor o hacienda',
    'portal.programacao.nova.dia': 'Día de carga',
    'portal.programacao.nova.reprogramarEsta': 'Reprogramar esta',
    'portal.programacao.nova.duplicadaTitulo': 'Este contrato ya tiene programación para {{dia}}',
    'portal.programacao.nova.duplicadaTexto': 'Para cambiar las cargas, reprograme la que ya existe.',
    'portal.programacao.nova.secaoCargas': 'Cargas',
    'portal.programacao.nova.quantidade': 'Cantidad',
    'portal.programacao.nova.ateN': 'Hasta {{n}}',
    'portal.programacao.nova.primeiro': 'Primer horario',
    'portal.programacao.nova.intervalo': 'Intervalo entre cargas',
    'portal.programacao.nova.enviar': 'Enviar programación',
    'portal.programacao.nova.enviada': 'Programación enviada. El programador ya fue avisado.',
    'portal.programacao.nova.enviadaPrevia': 'Previa enviada. Confírmela cuando sepa las cargas del día.',
    'portal.programacao.nova.confirmarTitulo': '¿Enviar la programación?',
    'portal.programacao.nova.confirmarPrevia': '¿Enviar la previa?',
    'portal.programacao.nova.confirmarTexto': '{{qtd}} en el contrato {{contrato}}, para {{dia}}.',

    'portal.programacao.reprogramar.titulo': 'Reprogramar',
    'portal.programacao.reprogramar.tituloConfirmar': 'Confirmar la previa',
    'portal.programacao.reprogramar.secaoPrevia': 'Esta programación es una previa',
    'portal.programacao.reprogramar.manter': 'Seguir como previa',
    'portal.programacao.reprogramar.manterTexto': 'Envía los cambios y usted confirma después.',
    'portal.programacao.reprogramar.confirmar': 'Confirmar la programación',
    'portal.programacao.reprogramar.confirmarTexto': 'La previa pasa a ser la programación del día, con los cambios de esta pantalla.',
    'portal.programacao.reprogramar.secaoCargas': 'Cargas',
    'portal.programacao.reprogramar.nadaMudou': 'Nada cambió todavía',
    'portal.programacao.reprogramar.extras': 'Cargas nuevas',
    'portal.programacao.reprogramar.reducoes': 'Cargas que salen',
    'portal.programacao.reprogramar.horarios': 'Horarios cambiados',
    'portal.programacao.reprogramar.viraConfirmada': 'Pasa a confirmada',
    'portal.programacao.reprogramar.revisar': 'Revisar y enviar',
    'portal.programacao.reprogramar.revisaoTitulo': 'Confirmar la reprogramación',
    'portal.programacao.reprogramar.revisaoConfirmar': 'Confirmar la programación',
    'portal.programacao.reprogramar.antes': 'Antes',
    'portal.programacao.reprogramar.agora': 'Ahora',
    'portal.programacao.reprogramar.legenda': 'Resaltados, los horarios que cambian.',
    'portal.programacao.reprogramar.enviar': 'Enviar',
    'portal.programacao.reprogramar.enviada': 'Reprogramación enviada. El programador ya fue avisado.',
    'portal.programacao.reprogramar.confirmada': 'Programación confirmada. El programador ya fue avisado.',
    'portal.programacao.reprogramar.mudou': 'La programación cambió mientras usted editaba. La pantalla se actualizó; revise y envíe de nuevo.',

    'portal.programacao.detalhe.titulo': 'Programación {{contrato}}',
    'portal.programacao.detalhe.carga': 'Carga',
    'portal.programacao.detalhe.horario': 'Horario',
    'portal.programacao.detalhe.cavalo': 'Tractor',
    'portal.programacao.detalhe.carretas': 'Remolques',
    'portal.programacao.detalhe.motorista': 'Conductor',
    'portal.programacao.detalhe.enviadaEm': 'Enviada el',
    'portal.programacao.detalhe.confirmadaEm': 'Confirmada el',
    'portal.programacao.detalhe.envios': 'Envíos',
    'portal.programacao.detalhe.semCargas': 'Ninguna carga en esta programación.',
    'portal.programacao.detalhe.ajustesTitulo': 'Ajustes del equipo',
    'portal.programacao.detalhe.ajustesTexto': 'El equipo ajustó esta programación. Si algo no coincide, hable con el equipo.',
    'portal.programacao.detalhe.entraram': 'Entraron',
    'portal.programacao.detalhe.sairam': 'Salieron',
    'portal.programacao.detalhe.horariosAlterados': 'Horarios cambiados: {{n}}',
    'portal.programacao.detalhe.placasTitulo': 'Placas que van a atender',
    'portal.programacao.detalhe.placasTexto': 'Las placas que el programador liberó, para emitir la factura.',
    'portal.programacao.detalhe.semPlacas': 'El programador todavía no liberó las placas de esta programación.',
  },
}
